
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"528","height":"126","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d)"}},[_c('path',{attrs:{"d":"M45.76 117C56.596 78.042 166.58 19.605 248.934 46.077 439.765 107.417 479.74 32.424 522 1.624c-83.256-4.495-123.098 14.772-217.261 74.42C207.757 137.478-.835 54.068 5.125 1.624","stroke":"#D49F4E"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d","x":".5","y":".5","width":"526.93","height":"124.634","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow","result":"shape"}})])])])
          )
        }
      }
    